(function () {

  function startFilter(product) {
    if (!product || !product.options) return;

    var colorIndex = product.options.findIndex(function (o) {
      var name = typeof o === 'string' ? o : (o.name || '');
      return ['cor', 'color', 'colour'].includes(name.toLowerCase());
    });
    if (colorIndex === -1) {
      console.warn('[VGF] Nenhuma opção de cor encontrada. Opções:', product.options);
      return;
    }

    var allColors = [...new Set(
      product.variants.map(function (v) {
      var val = Array.isArray(v.options) ? v.options[colorIndex] : v['option' + (colorIndex + 1)];
      return (val || '').toLowerCase().trim();
      })
    )];
    console.log('[VGF] Cores detectadas:', allColors);

    function imagePertenceACor(img, color) {
      var alt = (img.getAttribute('alt') || '').toLowerCase();
      var src = (img.getAttribute('src') || '').toLowerCase();
      return alt.includes(color) || src.includes(color);
    }

    function filterGallery(colorValue) {
      var color = colorValue.toLowerCase().trim();
      console.log('[VGF] Filtrando para cor:', color);

      var items = document.querySelectorAll(
        'media-gallery li.product-media-container, ul.media-gallery__grid li'
      );
      console.log('[VGF] Itens encontrados na galeria:', items.length);

      items.forEach(function (item) {
        var img = item.querySelector('img');
        if (!img) return;

        var temCor = allColors.some(function (c) { return imagePertenceACor(img, c); });

        // Sem nenhuma cor identificável → imagem comum, sempre exibe
        if (!temCor) {
          item.style.display = '';
          return;
        }

        item.style.display = imagePertenceACor(img, color) ? '' : 'none';
      });
    }

    function getSelectedVariant() {
      var input = document.querySelector('[name="id"]');
      if (!input) return null;
      var id = parseInt(input.value);
      return product.variants.find(function (v) { return v.id === id; }) || null;
    }

    function applyFilter() {
      var v = getSelectedVariant();
      if (v) filterGallery(v.options[colorIndex]);
    }

    // Evento nativo do Horizon
    document.addEventListener('variant:changed', function (e) {
      console.log('[VGF] variant:changed', e.detail);
      if (e.detail && e.detail.variant) {
        filterGallery(e.detail.variant.options[colorIndex]);
      }
    });

    // Fallback observando o input hidden
    var input = document.querySelector('[name="id"]');
    if (input) {
      new MutationObserver(applyFilter).observe(input, { attributes: true, attributeFilter: ['value'] });
      input.addEventListener('change', applyFilter);
    }

    // Aplica ao carregar
    applyFilter();
  }

  // Tenta via fetch (mais confiável no Horizon)
  var handle = window.location.pathname.match(/\/products\/([^/?#]+)/);
  if (!handle) return;

  fetch('/products/' + handle[1] + '.js')
    .then(function (r) { return r.json(); })
    .then(function (data) {
      console.log('[VGF] Produto carregado via fetch:', data.title);
      startFilter(data);
    })
    .catch(function (e) {
      console.error('[VGF] Erro ao carregar produto:', e);
    });


})();